<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="mixGetContratoActividadesTodas"
      :items-per-page="20">
      <template v-slot:[`item.tipo`]="{ item }">
        {{ getTipo(item.tipo) }}
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.descripcion`]="{ item }">
        <cortar-texto
          :texto="item.descripcion">
        </cortar-texto>
      </template>
      <template v-slot:[`item.marcarResuelto`]="{ item }">
        <BotonMarcarProbelmaResuelto
        :contratoActividad="item" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import mixActividadesProblemas from './mixActividadesProblemas';
import CortarTexto from '@/components/CortarTextos.vue';
import BotonMarcarProbelmaResuelto from './BotonMarcarProblemaResuelto.vue';

export default {
  name: 'ActividadesProblemas',
  mixins: [mixActividadesProblemas],
  components: {
    CortarTexto,
    BotonMarcarProbelmaResuelto,
  },
  data() {
    return {
      headers: [
        {
          text: 'Contrato',
          align: 'start',
          sortable: false,
          value: 'contrato.numero',
        },
        {
          text: 'Tipo',
          value: 'tipo',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Frente', value: 'frente.descripcion', width: '250', sortable: false,
        },
        {
          text: 'Fecha',
          value: 'fecha',
          align: 'center',
          sortable: false,
        },

        { text: 'Descripción', value: 'descripcion', sortable: false },
        {
          text: 'Marcar como Resuelto', align: 'center', value: 'marcarResuelto', sortable: false,
        },
      ],
    };
  },
  methods: {
    getTipo(tipo) {
      if (!tipo) return '';
      switch (tipo) {
        case 1:
          return 'Diario';
        case 2:
          return 'Informes';
        case 3:
          return 'Album';
        default:
          return '';
      }
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
